import { Model } from "pinia-orm";
import { Cycle, Domain } from "@/models";

export default class DomainVersion extends Model {
  static entity = "domainVersions";
  static primaryKey = "uuid";

  static fields() {
    return {
      uuid: this.uid(""),
      version: this.string(""),
      code: this.string(""),
      isActive: this.boolean(true),
      jurisdictionJudgment: this.string(""),
      showOnCertificate: this.boolean(false),

      // Foreign keys
      domainUuid: this.string(""),
      domainData: this.belongsTo(Domain, "domainUuid"),
      cyclesList: this.hasMany(Cycle, "domainVersionUuid"),
    };
  }
}
